const teamLeader: Permission = {
  order: 5,
  label: 'Team Leader',
  rules: {
    dashboard: { view: true, edit: true, viewOwnTeamOnly: true, viewSubPage: true },
    documents: { view: false, create: false, edit: false, delete: false },
    timeline: { view: true, create: false, viewOwnTeamOnly: true, edit: false, delete: false, restore: false, permanentDelete: false },
    dailyLog: {
      view: true,
      create: true,
      edit: true,
      delete: true,
      restore: false,
      permanentDelete: false,
      viewSubPage: false,
      previousStatus: false,
      sendSMS: true,
      documents: { view: true, create: true, edit: true, delete: true }
    },
    priceAnalysis: { view: false, edit: false },
    map: { view: true },
    projectPage: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    projectList: { view: true, viewSameOrganizationOnly: true, create: false, edit: false, delete: false, restore: false, permanentDelete: false, viewSubPage: false },
    projectDescription: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    projectAnalysis: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    report: { view: false, viewSelfOnly: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    organizations: { view: true, create: false, edit: false, delete: false, restore: false, permanentDelete: false, viewSubPage: false },
    organizationPage: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    activities: { view: true, create: false, edit: false, delete: false, restore: false, permanentDelete: false, editActivityPriceType: false },
    materials: { view: true, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    equipments: { view: true, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    employees: { view: true, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    teams: { view: true, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    administration: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false }
  },
  value: 'teamLeader'
};

export default teamLeader;
